/*
 * 订单管理设置
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 19:45:01
 * @Last Modified by: zhiwei.luo@zuolin.com
 * @Last Modified time: 2021-04-16 09:56:39
 */

const api = {
	listOrdersByStore: '/order/listOrdersByStore',   // 分页获取订单列表
	exportListByPage: '/order/exportListByPage', // 导出excel、
	exportOrderList: '/order/exportOrderList',   // 导出订单
	prepareOrder: '/order/prepare', // 订单配货
	cancelPayOrder: '/order/cancelPayOrder', // 取消订单
	deliveryOrder: '/order/delivery', // 配送订单
	listExpressByCd: '/express/listByCd', // 获取快递列表
	modifyOrder: '/order/modify', // 修改订单
	closeCanteenOrderItem: '/order/closeOrderItemGood', // 菜品消单
	orderDetail: '/order/getOrderByStore', // 订单详情
	getEnabledPointSystemInfo: '/integralMall/getEnabledPointSystemInfo', // 获取经商城系统信息
	waitOrSendOrder: '/order/goodsWaitBuyerToPick', // 商家备货/发货
	refund: '/order/refund',  //商家主动退款
	partialRefund: '/order/partialRefund', //商家部分商品退款
	findNotRefundInfo: '/order/findNotRefundInfo', // 查询未退款商品信息
	issueRefundInfo: '/order/issueRefundInfo', // 退款明细
	listPaymentType: '/order/listPaymentType', //获取支付方式
	listAllOfflineAccounts: '/merchant/listAllOfflineAccounts', //列出所有商家的线下账户
	receiveRemittance: '/order/receiveRemittance', //汇款已到账
};

const routes = {
	'/orders-manage': '交易记录',
	'/orders-manage/detail': '交易详情',
};

export {
	api,
	routes,
};
